"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bellNumbersDependencies = void 0;
var _dependenciesAddScalarGenerated = require("./dependenciesAddScalar.generated.js");
var _dependenciesIsIntegerGenerated = require("./dependenciesIsInteger.generated.js");
var _dependenciesIsNegativeGenerated = require("./dependenciesIsNegative.generated.js");
var _dependenciesStirlingS2Generated = require("./dependenciesStirlingS2.generated.js");
var _dependenciesTypedGenerated = require("./dependenciesTyped.generated.js");
var _factoriesAny = require("../../factoriesAny.js");
/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */

var bellNumbersDependencies = exports.bellNumbersDependencies = {
  addScalarDependencies: _dependenciesAddScalarGenerated.addScalarDependencies,
  isIntegerDependencies: _dependenciesIsIntegerGenerated.isIntegerDependencies,
  isNegativeDependencies: _dependenciesIsNegativeGenerated.isNegativeDependencies,
  stirlingS2Dependencies: _dependenciesStirlingS2Generated.stirlingS2Dependencies,
  typedDependencies: _dependenciesTypedGenerated.typedDependencies,
  createBellNumbers: _factoriesAny.createBellNumbers
};